export default __webpack_public_path__ + "static/media/profile-img.12d0d0d9.png";